import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import AddIcon from '@mui/icons-material/Add';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const McPreferences = ({ open, onClose }) => {
  // Removed duplicate state declaration
  // const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    // setOpen(true); // Removed redundant state setting
    onClose(true);
  };
  const handleClose = () => {
    // setOpen(false); // Removed redundant state setting
    onClose(false);
  };
  
  return (
    <div className="custom-dialog">
      <BootstrapDialog
        onClose={handleClose}
        open={open}
        maxWidth="md"
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <div className='row'>
            <div className='col-md-12'>
              <h3 className='pop-title'>Manage Consent Preferences</h3>
              <p>While using Jio Sign, your activities create data that will be:</p>
            </div>
          </div>
          <div className='note-box mt-2'>
            <div className='row'>
              <div className='col-md-12'>
                <ul className='note-list'>
                  <li>Used by Jio Sign to offer you better and more customized services.</li>
                  <li>Jio Sign uses this data in accordance with your permission (consent), details of which are clearly mentioned below.</li>
                  <li>So that YOU are always aware of how we use your data, and YOU have total control on managing the usage of your data.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <p>Privacy policy and Terms & Conditions</p>
              <p>Manage Consent Preferences:</p>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<AddIcon />}
                  id="panel1-header"
                  className='d-flex align-items-center'
                >
                  Data used by Jio Sign
                  <FormControlLabel control={<Switch />} className='ms-3' />
                </AccordionSummary>
                <AccordionDetails>
                  <div className='row'>
                    <div className='col-md-3'>
                      <h4 className='note-label'>
                        Data Fields <span>Profile</span>
                      </h4>
                    </div>
                    <div className='col-md-3'>
                      <h4 className='note-label'>
                        Status <span className='text-success'>Active</span>
                      </h4>
                    </div>
                    <div className='col-md-3'>
                      <h4 className='note-label'>
                        Frequency <span className='text-success'>Active</span>
                      </h4>
                    </div>
                    <div className='col-md-3'>
                      <h4 className='note-label'>
                        Fetch Type <span>Periodic</span>
                      </h4>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<AddIcon />}
                  id="panel2-header"
                  className='d-flex align-items-center'
                >
                  Data shared by other entities
                  <FormControlLabel control={<Switch />} className='ms-3' />
                </AccordionSummary>
                <AccordionDetails>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                  malesuada lacus ex, sit amet blandit leo lobortis eget.
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        </DialogContent>
      </BootstrapDialog>
    </div>
    
  );
};

export default McPreferences;
